import React from "react";
import { CalendarCheck, Percent, Truck } from "lucide-react";
import { Button } from "randmarcomps";
 
const ReturnsActions: React.FC = () => {
  return (
    <div className="mx-1 my-2 flex w-[260px] flex-col gap-3">
      <div className="space-y-2">
        <p className="px-2 text-xs font-semibold uppercase tracking-wide text-slate-500">Policies</p>
        <div className="flex flex-col gap-1">
          <Button variant="ghost" disabled className="justify-start gap-2 px-2">
            <CalendarCheck className="h-4 w-4" aria-hidden="true" />
            Edit days limit
          </Button>
          <Button variant="ghost" disabled className="justify-start gap-2 px-2">
            <Percent className="h-4 w-4" aria-hidden="true" />
            Edit defective allowance
          </Button>
        </div>
      </div>

      <hr className="border-slate-100" />

      <div className="space-y-2">
        <p className="px-2 text-xs font-semibold uppercase tracking-wide text-slate-500">Utilities</p>
        <div className="flex flex-col gap-1">
          <Button variant="ghost" disabled className="justify-start gap-2 px-2">
            <Truck className="h-4 w-4" aria-hidden="true" />
            Create return label
          </Button>
        </div>
      </div>

      <div className="rounded-xl border border-slate-100 bg-slate-50 p-3">
        <p className="text-[13px] text-slate-600">These actions are not available yet in the Manufacturer portal.</p>
      </div>
    </div>
  );
};

export default ReturnsActions;
